import { createReducer } from 'redux-act';
import { setUser, setAuthentication, clearAuthentication } from './userActions';

const initialState = {
  qhUserId: undefined,
  flightBookerToken: undefined,
  hasDismissedSearchMessaging: undefined,
  hasDismissedLoginTooltip: undefined,
  hasDismissedWelcomeMessage: undefined,
  authentication: {
    memberId: undefined,
    accessToken: undefined,
    title: undefined,
    firstName: undefined,
    lastName: undefined,
    emailAddress: undefined,
    phoneNumber: undefined,
    pointsBalance: undefined,
    membershipTier: undefined,
  },
};

export const reducer = createReducer(
  {
    [setUser]: (state, user) => ({
      ...state,
      ...user,
    }),

    [setAuthentication]: (state, authentication) => ({
      ...state,
      authentication: {
        ...authentication,
      },
    }),

    [clearAuthentication]: (state) => ({
      ...state,
      authentication: {
        ...initialState.authentication,
      },
    }),
  },
  initialState,
);
